var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureTileIcon06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-2M40.121 24.879l1.415-1.415M41 27h2M40.121 29.121l1.415 1.415M38 30v2M35.879 29.121l-1.415 1.415M35 27h-2M35.879 24.879l-1.415-1.415",
    stroke: "#ACADFF"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#ACADFF",
    cx: 38,
    cy: 27,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.86 23.18C24.8 23.988 21 27.6 21 32c0 5 4.9 9 11 9a10.55 10.55 0 003.1-.4L41 43l-.6-5.2a9.125 9.125 0 001.991-2.948",
    stroke: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon06);
export default __webpack_public_path__ + "static/media/feature-tile-icon-06.74b0477e38710535bd0e2526d669b6f8.svg";
export { ForwardRef as ReactComponent };